exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".app-layout[data-v-0b60ef1b]{display:flex;flex-direction:column;min-height:100vh;min-height:100dvh}.app-layout footer[data-v-0b60ef1b]{margin-top:auto}", ""]);

